var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pr-2"},[_vm._v(_vm._s(_vm.confirmationMessage))])
}
var staticRenderFns = []

export { render, staticRenderFns }